<script setup>
import {defineProps} from "vue";
import useHelper from "@/composables/useHelper";

const { getContentTypeTitle } = useHelper();

const props = defineProps({
    content: Object
});

</script>

<template>
    <div>
        <div class="text-xs text-pink-500">
            <div class="w-6 h-1.5 bg-pink-500 inline-block mt-3  mr-1 rounded-lg"></div>
            {{ getContentTypeTitle(content) }}
        </div>
        <p class="my-1 text-xl capitalize text-slate-600 font-medium ltr:mr-4 rtl:ml-4">{{ content.name }}</p>
        <div class="text-xs text-slate-500">
            <span>{{ $tt('content_card__by') }}: </span>
            <span class="text-slate-700">{{ content.mentor_first_name + " " + content.mentor_last_name }}</span>
        </div>
    </div>
</template>

